import apiClient from "@/config/api";

const RESOURCE = "/properties";

const actions = {
    getProperties({ commit }, page=1) {
        return new Promise((resolve, reject) => {
            console.log("params: ", page)
            const fullpath = `${RESOURCE}?page=${page}`;
            
            apiClient.get(fullpath)
                .then(res => {
                    commit("SET_PROPERTIES", res.data.data);
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
           
        })
    },
    getPropertiesFiltered({ commit }, filters) {
        commit("CLEAR_PROPERTIES");
        return new Promise((resolve, reject) => {
            const fullpath = `${RESOURCE}?page=${filters.page || 1}&objective=${filters.objective}`;
            apiClient.get(fullpath)
                .then(res => {
                    commit("SET_PROPERTIES", res.data.data);
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
        })
    },
    getPropertiesMultipleFilters({ commit }, filters) {
        commit("CLEAR_PROPERTIES");
        return new Promise((resolve, reject) => {
            const params = new URLSearchParams({ page: filters.page || 1 });
            const set = (key, val) => { if (val != null && val !== '') params.set(key, val); };
            set('per_page',        filters.per_page);
            set('objective',       filters.objective);
            set('property_type',   filters.property_type);
            set('condition',       filters.condition);
            set('location',        filters.location);
            set('bedroom_amount',  filters.bedroom_amount);
            set('bathroom_amount', filters.bathroom_amount);
            set('garage_space',    filters.garage_space);

            apiClient.get(`${RESOURCE}?${params.toString()}`)
                .then(res => {
                    commit("SET_PROPERTIES", res.data.data);
                    resolve(res.data.data);
                })
                .catch(err => {
                    reject(err);
                    console.error("API Error:", err);
                });
        });
    },
    // eslint-disable-next-line no-unused-vars
    getPropertyBySlug({ commit }, slug) {
        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/slug/${slug}`)
                .then(res => {
                    // commit();
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
        })
    }
}
export default actions;